import { Link } from 'react-router-dom';

export function Logo() {
  return (
    <Link to="/" className="flex items-center gap-3 group">
      <span className="text-3xl group-hover:animate-float">🦁</span>
      <div className="flex flex-col">
        <span className="text-xl font-bold text-gradient">
          Зоопарк Галактики
        </span>
        <span className="text-xs text-gray-400">
          3D Энциклопедия животных
        </span>
      </div>
    </Link>
  );
}
